const messages = {
  completeShip: 'Complete Ship',
  orderIsCreatedByRetailer: (formattedCreatedAt) =>
    `Created by Retailer (${formattedCreatedAt}).`,
  divisionCode: 'Division Code',
  error: 'Error',
  errorLoading: 'Error loading status.',
  event: 'Event',
  exportStatus: 'Export Status',
  linesheet: 'Linesheet',
  modified: 'Modified',
  poNumber: 'PO#',
  retailer: 'Retailer',
  hub: 'Hub',
  salesRep: 'Sales Rep',
  shippingCode: 'Shipping Code',
  status: 'Status',
  total: 'Total',
  openOrderToView: 'Open order to view.',
  paymentStatus: 'Payment Status',
  paymentStatusLoading: 'Payment status loading',
  priceType: 'Price Type',
  invoiceStatus: 'Invoice Status',
  invoiceStatusLoading: 'Invoice status loading',
  type: 'Type',
  units: 'Units',
  budgets: 'Budget',
  statusCancelled: 'Cancelled',
  statusApproved: 'Approved',
  statusNotes: 'Notes',
  statusInProgress: 'Draft',
  statusPending: 'Pending',
  statusShipped: 'Shipped',
  multipleStatuses: 'Multiple',
  statusFailed: 'Failed',
  statusScheduled: 'Scheduled',
  statusSuccess: 'Success',
  statusNone: 'None',
  totalDiscountError:
    'There was an error calculating your combined total. Clear all in the filter box and reselect to continue.',
  modifiedSinceLastExport: 'Modified since last export',
  wholesaleCalculatorTitle: 'Total: Selected Orders',
  warehouse: 'Warehouse',
}

export default messages
